import React from 'react';
import { connect } from 'react-redux';
import { updateField } from '../actions/FormActions';

const Textarea = ({label, name, value, tooltip, changeHandler}) => {
  let classes = 'group textarea';
  classes = tooltip ? classes + ' has-tooltip' : classes;

  return (
    <div className={classes}>
      
      <textarea name={name} value={value} onChange={changeHandler} placeholder={label} />
      <label htmlFor={name}>{label}</label>

      {tooltip ?
        <a tabIndex="0" className="btn tooltip" role="button" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="right" data-bs-html="true" data-bs-title="Tool Tip:" data-bs-content={tooltip}>?</a> : null
      }

    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const field = ownProps.field;
  return {
    label: field.label,
    name: field.name,
    value: field.value,
    tooltip: field.tooltip
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeHandler: (event) => {
      const target = event.target;
      const name = target.name
      const value = target.value;
      dispatch(updateField(name, value));
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Textarea);